import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";

export const GET_ROOKIE_JOBS = gql`
  query GetRookieJobs($districtId: Int!) {
    rookieJobs(districtId: $districtId) {
      id
      bicID
      name
      jobEducationalPaths {
        id
        name
      }
      scholasticDuration {
        durationName
        position
      }
      requirementsByType {
        requirementTypes {
          requirementType {
            id
            bicID
            typeName
          }
          requirements {
            id
            bicID
          }
        }
      }
      image {
        ...imageFields
      }
      schoolSubjectMappings {
        jobSchoolSubject {
          id
        }
      }
      interestFields {
        id
      }
      jobLinkMappings {
        id
      }
      jobSalary {
        entryValue
      }
      jobRedirects {
        bicID
        jobName
        redirectType
      }
      jobWorkFields {
        name
        bicID
      }
    }
  }
  ${ImageFragment}
`;
